import { render } from "./TelemedicineContentEn.vue?vue&type=template&id=39d97f47&scoped=true"
import script from "./TelemedicineContentEn.vue?vue&type=script&lang=js"
export * from "./TelemedicineContentEn.vue?vue&type=script&lang=js"

import "./TelemedicineContentEn.vue?vue&type=style&index=0&id=39d97f47&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d97f47"]])

export default __exports__